// Externe Bibliotheken
import React, { Component, memo } from 'react';
import { Link } from 'react-router';
import _ from 'lodash';

// Interne Module
import * as storage from '@/_helper/storage';
import { deactivateServices } from '@/_helper/deactivateServices';
import tracking from '@/_helper/tracking';
import { affiliate_checkIsAllowToBookService, checkTripEnded } from '@/_helper/checkAccess';
import { getRegion, tripStartCountdown } from '@/_helper/bookingDetailsHelper';
import { checkTripStarts } from '@/_helper/checkTripStarts';
import { paymentAlertText } from '@/_data/contentText';
import { AppContext } from '@/context/AppContext';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import TravelTile from '@/comp/travelTile';
import ExtraServices from '@/pages/extra-services';
import BookingDetails from '@/pages/booking-details';
import HeroTeaser from '@/comp/heroTeaser';
import SideNavigation from '@/comp/sideNavigation/SideNavigation';
import Documents from '@/pages/documents';
import StatusPage from '@/comp/statusPage/statusPage';
import contactModal from '@/comp/overlayModal/contactModal';
import tourGuideModal from '@/comp/overlayModal/tourGuide/tourGuideModal';
import EmergencyContactModal from '@/comp/overlayModal/emergencyContactModal/EmergencyContactModal.js';

// Styles
import './index.scss';

class Index extends Component {
    #pathNameMapping = {};
    #bookingState;
    #sideBarNavigationList = [];
    #defaultFirstStep = 0;
    static contextType = AppContext;

    constructor(props) {
        super(props);

        // set document title
        this.documentTitle = `Meine Buchung ${window.$documentTitle}`;

        // remove book states
        sessionStorage.removeItem('bookStates');

        /**
         * BookingState:
         *  OK -> Buchung bestätigt
         *  XX -> Buchung storniert
         *  NO -> Buchung abgesagt
         *  over -> Buchung in der Vergangenheit
         */
        const bookingData = storage.get('bookingData') ? storage.get('bookingData') : null;
        const data = bookingData?.data ? storage.get('bookingData').data : null;

        if (data !== null && data !== undefined && data.serviceInformation?.package) {
            if (
                (data.serviceInformation.package.state === 'OK' ||
                    data.serviceInformation.package.state === 'TB' ||
                    data.serviceInformation.package.state === 'MO') &&
                data.searchParams.retDate &&
                tripStartCountdown(data.searchParams.retDate) === false
            ) {
                this.#bookingState = 'over';
            } else {
                this.#bookingState =
                    data.serviceInformation.package.state === 'MO' || data.serviceInformation.package.state === 'TB'
                        ? 'OK'
                        : data.serviceInformation.package.state;
            }
            if (data.allowedInteractions?.login?.reason === 'cruise-apis') {
                this.#defaultFirstStep = 1;
            }
        } else {
            this.#bookingState = 'NO';
        }

        window.$bookingState = this.#bookingState;

        // init states
        this.state = {
            isLoading: false,
            currentStep: this.#defaultFirstStep,
            bookingData: bookingData,
            data: data,
            bookingNumber: storage.get('bookingNumber') ? storage.get('bookingNumber') : null,
            alertCount: {},
            alertTotalCount: 0,
        };

        // deactivate services
        deactivateServices();

        // changeView
        this.changeView();

        this.bookingDetails = this.bookingDetails.bind(this);
    }

    changeView() {
        if (typeof window !== 'undefined') {
            window.addEventListener(
                'resize',
                _.debounce(() => {
                    if (window.innerWidth >= 920 && window.$browserInfo.device === 'mobile') {
                        window.location.reload();
                    }
                    if (window.innerWidth <= 920 && window.$browserInfo.device === 'not-mobile') {
                        window.location.reload();
                    }
                }, 200)
            );
        }
    }

    componentDidMount() {
        // alert count
        this.alertCount();

        document.querySelector('html').classList.add('redesign');

        this.setState({
            isLoading: true,
            currentStep: this.#defaultFirstStep,
        });

        let $this = this;

        window.addEventListener('storage', (event) => {
            switch (event.key) {
                case 'newData':
                    let bookingData = storage.get('bookingData');
                    $this.setState({
                        bookingData: bookingData,
                    });
                    break;
                default:
            }
        });
    }

    componentWillUnmount() {
        if (window.$browserInfo.device === 'mobile') {
            document.querySelector('html').removeAttribute('style');
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        document.querySelector('html').classList.add('redesign');

        let currentStep = this.#defaultFirstStep,
            $this = this;
        if (this.#bookingState) {
            this.#pathNameMapping = {};
            if (this.state.bookingData?.data?.allowedInteractions?.login?.reason === 'cruise-apis') {
                this.#pathNameMapping['buchung-verwalten'] = 1;
            } else if (this.#bookingState === 'OK') {
                this.#pathNameMapping['buchungsuebersicht'] = 0;
                this.#pathNameMapping['buchung-verwalten'] = 1;
                this.#pathNameMapping['dokumente-anzeigen'] = 2;
                this.#pathNameMapping['zusatzleistung'] = 3;
                this.#pathNameMapping['zahlungsstatus'] = 4;
                this.#pathNameMapping['stornierungsoptionen'] = 5;
                this.#pathNameMapping['reise-reklamieren'] = 6;
            } else if (this.#bookingState === 'over') {
                this.#pathNameMapping['buchungsuebersicht'] = 0;
                this.#pathNameMapping['zahlungsstatus'] = 4;
                this.#pathNameMapping['reise-reklamieren'] = 6;
            } else if (this.#bookingState === 'XX') {
                this.#pathNameMapping['zahlungsstatus'] = 4;
            } else {
                this.#pathNameMapping['buchungsuebersicht'] = 0;
            }

            // check : deactive services
            _.forEach(window.$deactivateExtras, function (service) {
                switch (service.toLowerCase()) {
                    case 'cancellation':
                        delete $this.#pathNameMapping.stornierungsoptionen;
                        break;
                    default:
                        break;
                }
            });

            const pathname = this.props.location?.pathname?.replaceAll('/', '');

            // set step ? default step
            currentStep =
                this.#pathNameMapping[pathname] !== undefined
                    ? this.#pathNameMapping[pathname]
                    : window.$affiliate
                      ? this.#sideBarNavigationList[0]?.index
                      : this.#defaultFirstStep;

            if (window.$browserInfo.device === 'mobile' && currentStep !== 0) {
                document.querySelector('html').style.overflow = 'hidden';
            } else if (currentStep === 0 && document.querySelector('html').style.overflow === 'hidden') {
                document.querySelector('html').style.overflow = 'auto';
            }
        }

        if (prevState.currentStep !== currentStep) {
            this.setState({
                currentStep: currentStep,
            });

            // set document title with count alerts by sidebar navigation list entry
            this.setDocumentTitle();
        }
    }

    alertCount() {
        let data = this.state.data;

        if (!data) {
            return false;
        }

        // set alert object : count by sidebar navigation list entry
        let alertCount = {
            // manageBooking
            // -> alertApisData, haveToFlightAlternativesFromMail, haveToFTCRebooking
            manageBooking:
                this.#bookingState === 'OK' &&
                [data?.alertApisData, data?.haveToFlightAlternativesFromMail, data?.haveToFTCRebooking].filter((o) => o)
                    .length,
        };

        // set alert total count
        let alertTotalCount = 0;
        Object.values(alertCount).forEach((value) => {
            alertTotalCount += value;
        });

        // set states
        this.setState(
            {
                alertCount: alertCount,
                alertTotalCount: alertTotalCount,
            },
            function () {
                this.setDocumentTitle();
            }
        );
    }

    setDocumentTitle() {
        const currentNavItem = this.#sideBarNavigationList.find((e) => e.index === this.state.currentStep);
        const documentTitle = `${currentNavItem?.label ?? 'Buchungsübersicht'} ${window.$documentTitle}`;
        const { alertTotalCount } = this.state;

        document.title = alertTotalCount > 0 ? `(${alertTotalCount}) ${documentTitle}` : documentTitle;
    }

    updatePayment() {
        const { data } = this.state;

        const paymentAlert = <article className="info-card">{paymentAlertText}</article>;

        const openPaymentTile = (
            <TravelTile
                name="payment"
                icon="euro"
                headline="Zahlung tätigen / Zahlart ändern"
                description="Begleichen Sie offene Zahlungen für Ihre Reise und ändern Sie optional die Zahlart."
                state="show"
                link="zahlung"
                linkType="internal"
                target="_blank"
            />
        );

        if (data?.frontendParams?.paymentDetails?.pending) {
            return (
                <article className="info-card">
                    Danke für Ihre Zahlung. Diese befindet sich gerade in Bearbeitung. Es kann daher ein paar Stunden
                    dauern, bis die Änderungen im Kundenbereich für Sie sichtbar sind.
                </article>
            );
        } else if (
            data?.frontendParams?.price?.fullyPaid ||
            data?.allowedInteractions?.payment?.deposit ||
            data?.allowedInteractions?.payment?.full ||
            data?.allowedInteractions?.payment?.refund
        ) {
            if (
                data?.frontendParams?.price?.fullyPaid ||
                (this.#bookingState === 'OK' &&
                    (data.allowedInteractions.payment.deposit || data.allowedInteractions.payment.full)) ||
                ((this.#bookingState === 'OK' || this.#bookingState === 'over' || this.#bookingState === 'XX') &&
                    data.allowedInteractions.payment.refund)
            ) {
                return (
                    <>
                        {data?.frontendParams.price.fullyPaid ? (
                            <TravelTile
                                name="payment-refund-update"
                                icon="euro"
                                headline="Reisepreis"
                                description="Sie haben Ihre Reise bereits komplett bezahlt."
                                state="is-already-booked"
                            />
                        ) : (
                            <>
                                {/* update payment data */}
                                {this.#bookingState === 'OK' &&
                                    (data?.allowedInteractions?.payment.deposit ||
                                        data?.allowedInteractions?.payment.full) &&
                                    openPaymentTile}
                                {/* update payment refund data */}
                            </>
                        )}
                        {data.allowedInteractions?.payment.refund && this.updatePaymentRefundData()}
                    </>
                );
            } else {
                return paymentAlert;
            }
        } else {
            return paymentAlert;
        }
    }

    updatePaymentRefundData() {
        // affiliate → check is allow to book service
        let service = 'paymentRefund';
        if (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) {
            return false;
        }

        return (
            <TravelTile
                name="payment-refund-update"
                icon="euro"
                headline="Erstattung durchführen"
                description="Geben Sie Ihre Bankinformationen an, um die Rückerstattung für Ihre Reise zu erhalten."
                state="show"
                link="rueckzahlung"
                linkType="internal"
                target="_blank"
            />
        );
    }

    hotelAlternativeSearch() {
        // affiliate → check is allow to book service
        let service = 'hotelChangeSearch';
        if (
            (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) ||
            this.state.bookingData?.data?.allowedInteractions?.login?.reason === 'cruise-apis'
        ) {
            return false;
        }

        const { data } = this.state;

        let completeUrl =
            window.$searchFrontendUrl +
            '/search?bookingId=' +
            this.state.bookingNumber +
            '&travelStart=' +
            storage.get('travelStart') +
            '&firstPaxName=' +
            storage.get('firstPaxName') +
            '&hash=' +
            storage.get('access_token') +
            '&step=hotel';

        // trigger linkout after redirect
        if (
            sessionStorage.getItem('linkOutTrigger') !== undefined &&
            sessionStorage.getItem('linkOutTrigger') === 'hotelChangeSearch'
        ) {
            sessionStorage.removeItem('linkOutTrigger');

            window.open(completeUrl, '_blank');
        }

        if (
            window.$allowHotelChangeSearch === 'true' &&
            data !== undefined &&
            (data.allowHotelRebooking === undefined || data.allowHotelRebooking === true)
        ) {
            return (
                <TravelTile
                    name="accommodation"
                    icon="location_away"
                    headline="Unterkunft ändern"
                    description="Auf Wunsch können Sie hier eine neue Unterkunft für Ihre Reise auswählen."
                    state="show"
                    link={completeUrl}
                    linkType="external"
                    target="_blank"
                />
            );
        }
    }

    flightAlternativeSearch() {
        // affiliate → check is allow to book service
        let service = 'flightChangeSearch';
        if (
            (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) ||
            this.state.bookingData?.data?.allowedInteractions?.login?.reason === 'cruise-apis'
        ) {
            return false;
        }

        const { data } = this.state;

        let completeUrl =
            window.$searchFrontendUrl +
            '/search?bookingId=' +
            this.state.bookingNumber +
            '&travelStart=' +
            storage.get('travelStart') +
            '&firstPaxName=' +
            storage.get('firstPaxName') +
            '&hash=' +
            storage.get('access_token') +
            '&step=flight';

        // trigger linkout after redirect
        if (
            sessionStorage.getItem('linkOutTrigger') !== undefined &&
            sessionStorage.getItem('linkOutTrigger') === 'flightChangeSearch'
        ) {
            sessionStorage.removeItem('linkOutTrigger');

            window.open(completeUrl, '_blank');
        }

        const needRebooking = data?.haveToFTCRebooking !== undefined && data?.haveToFTCRebooking;

        if (
            window.$allowFlightChangeSearch === 'true' &&
            data !== undefined &&
            (data.allowFTCRebooking === undefined || data.allowFTCRebooking === true)
        ) {
            return (
                <TravelTile
                    name="flight"
                    icon="flight"
                    headline="Flug ändern"
                    description={
                        needRebooking
                            ? 'Hier müssen Sie Ihren bisherigen Flug ändern und eine Alternative auswählen.'
                            : 'Bei Bedarf können Sie Ihren bisherigen Flug hier ändern und eine Alternative auswählen.'
                    }
                    state={needRebooking ? 'alert' : 'show'}
                    link={completeUrl}
                    linkType="external"
                    target="_blank"
                />
            );
        }
    }

    flightAlternativeATC() {
        // affiliate → check is allow to book service
        let service = 'flightAlternativeATC';
        if (
            (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) ||
            this.state.bookingData?.data?.allowedInteractions?.login?.reason === 'cruise-apis'
        ) {
            return false;
        }

        const { data } = this.state;

        let completeUrl =
            window.$searchFrontendUrl +
            '/flugalternativen' +
            '?bookingId=' +
            this.state.bookingNumber +
            '&travelStart=' +
            storage.get('travelStart') +
            '&firstPaxName=' +
            storage.get('firstPaxName');

        // trigger linkout after redirect
        if (
            sessionStorage.getItem('linkOutTrigger') !== undefined &&
            sessionStorage.getItem('linkOutTrigger') === 'flightAlternativeATC'
        ) {
            sessionStorage.removeItem('linkOutTrigger');

            window.open(completeUrl, '_blank');
        }

        if (data.haveToFlightAlternativesFromMail) {
            return (
                <TravelTile
                    name="flight"
                    icon="flight"
                    headline="Flugalternative auswählen"
                    description="Hier können Sie einen anderen Flug aus der Ihnen zugesandten <span class='noLineBreak'>E-Mail</span> auswählen."
                    state="alert"
                    link={completeUrl}
                    linkType="external"
                    target="_blank"
                />
            );
        }
    }

    changeSeatReservation() {
        const { data } = this.state;

        // affiliate → check is allow to book service
        let service = 'changeSeatReservationService';
        if (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) {
            return false;
        }

        if (data !== undefined && data.serviceInformation?.bookedSeats) {
            return (
                <TravelTile
                    name="changeSeatReservation"
                    icon="airline_seat_recline_normal"
                    headline="Sitzplatzreservierung (Flug) ändern"
                    description="Bei Bedarf können Sie Ihre Sitzplatzreservierung im Flugzeug  über den AurumTours Service ändern."
                    state="show"
                    linkType="modal"
                    target="_blank">
                    {contactModal()}
                </TravelTile>
            );
        }
    }

    changeExcursion() {
        const { data } = this.state;

        // affiliate → check is allow to book service
        let service = 'changeExcursionService';
        if (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) {
            return false;
        }

        if (data !== undefined && data.serviceInformation?.excursions && window.$content.extras.excursion?.active) {
            return (
                <TravelTile
                    name="changeExcursion"
                    icon="attractions"
                    headline="Ausflug ändern"
                    description="Auf Wunsch können Sie Ihren gebuchten Ausflug über den AurumTours Service ändern."
                    state="show"
                    linkType="modal"
                    target="_blank">
                    {contactModal()}
                </TravelTile>
            );
        }
    }

    cancellationService() {
        // affiliate → check is allow to book service
        let service = 'cancellationService';
        if (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) {
            return false;
        }

        const { data } = this.state;
        const { cancellation } = data?.allowedInteractions;

        if (!checkTripStarts() || cancellation?.completeCancellation) {
            if (data !== undefined && (data.serviceInformation.package.state === 'XX' || data.bookingCancelled)) {
                return (
                    <TravelTile
                        name="cancellation"
                        icon="free_cancellation"
                        headline="Reise stornieren"
                        description="Ihre Reise wurde storniert"
                        state="is-already-booked"
                    />
                );
            } else if (cancellation?.completeCancellation) {
                return (
                    <TravelTile
                        name="cancellation"
                        icon="free_cancellation"
                        headline="Reise stornieren"
                        description="Im nächsten Schritt können Sie Ihre komplette Reise einfach stornieren."
                        state="show"
                        link={'stornierung'}
                        linkType="internal"
                        target="_blank"
                    />
                );
            }
        } else {
            return (
                <div className="info-card">
                    Ihre Reise kann nicht mehr storniert werden.
                    <br />
                    <br />
                    Wir hoffen, Sie genießen Ihren Urlaub! Bei Problemen oder Fragen vor Ort, melden Sie sich bitte
                    umgehend beim AurumTours Serviceteam unter{' '}
                    <a href="mailto:service@aurumtours.de">service@aurumtours.de</a>.
                </div>
            );
        }
    }

    partialCancellation() {
        const { partialCancellation } = this.state.data?.allowedInteractions?.cancellation;

        let partialCancellationData = [];

        // cancelExcursion
        if (partialCancellation?.excursion) {
            partialCancellationData.push(
                <TravelTile
                    key="excursion"
                    name="cancellation-excursion"
                    icon="free_cancellation"
                    headline="Ausflug stornieren"
                    description="Im nächsten Schritt können Sie Ihren Ausflug stornieren."
                    state="show"
                    link={'leistung-stornieren/ausflug'}
                    linkType="internal"
                    target="_blank"
                />
            );
        }

        // cancelSeatReservation :
        if (
            !window.deactivateServices.includes('partialCancellationSeatReservation') &&
            partialCancellation?.seatReservation
        ) {
            partialCancellationData.push(
                <TravelTile
                    key="seatReservation"
                    name="cancellation-seatReservation"
                    icon="free_cancellation"
                    headline="Sitzplatzreservierung (Flug) <wbr/> stornieren"
                    description="Im nächsten Schritt können Sie Ihre gebuchten Sitzplätze stornieren."
                    state="show"
                    link={'leistung-stornieren/sitzplatzreservierung'}
                    linkType="internal"
                    target="_blank"
                />
            );
        }

        return Object.keys(partialCancellationData).length > 0 && partialCancellationData;
    }

    cancelExcursion() {
        const { data } = this.state;

        if (data?.allowedInteractions?.cancellation?.partialCancellation?.excursion) {
            return (
                <TravelTile
                    name="cancellation-excursion"
                    icon="free_cancellation"
                    headline="Ausflug stornieren"
                    description="Im nächsten Schritt können Sie Ihren Ausflug stornieren."
                    state="show"
                    link={'leistung-stornieren/ausflug'}
                    linkType="internal"
                    target="_blank"
                />
            );
        } else {
            return false;
        }
    }

    cancelSeatReservation() {
        const { data } = this.state;

        if (data?.allowedInteractions?.cancellation?.partialCancellation?.seatReservation) {
            return (
                <TravelTile
                    name="cancellation-excursion"
                    icon="free_cancellation"
                    headline="Sitzplatzreservierung (Flug) stornieren"
                    description="Im nächsten Schritt können Sie Ihre gebuchten Sitzplätze stornieren."
                    state="show"
                    link={'leistung-stornieren/sitzplatzreservierung'}
                    linkType="internal"
                    target="_blank"
                />
            );
        } else {
            return false;
        }
    }

    claim() {
        // affiliate → check is allow to book service
        let service = 'claim';
        if (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) {
            return false;
        }

        if (!checkTripEnded()) {
            return (
                <article className="claim info-card">
                    <p>Sie können eine Reklamation erst nach Reiseende hier einreichen.</p>
                    <p>
                        <b>Es ist wichtig, auftretende Mängel sofort während der Reise bei AurumTours zu melden.</b> Nur
                        so können wir Ihnen schnell und direkt helfen. Für nachträglich angezeigte Mängel besteht kein
                        Entschädigungsanspruch. Bitte bewahren Sie alle Zahlungsbelege, Quittungen etc. sorgfältig auf.
                    </p>
                    <p>
                        Bei Problemen oder Fragen nutzen Sie bitte das{' '}
                        <a rel="noopener noreferrer" href={`${window.$website}/service/kontakt`} target="_blank">
                            Kontaktformular
                        </a>
                        .
                    </p>
                </article>
            );
        } else {
            return (
                <TravelTile
                    name="claim"
                    icon="sync_problem"
                    headline="Reklamation"
                    description={
                        window.$claimEnabled !== 'false' && this.state.data?.allowClaim
                            ? 'Mit Ihrer Reise war etwas nicht in Ordnung? Reichen Sie Ihre Reklamation ganz einfach hier ein.'
                            : 'Sie haben bereits eine Reklamation zu Ihrer Reise eingereicht.'
                    }
                    state={
                        window.$claimEnabled !== 'false' && this.state.data?.allowClaim ? 'show' : 'is-already-booked'
                    }
                    link="reklamation"
                    linkType="internal"
                    target="_blank"
                />
            );
        }
    }

    updateExtraServices() {
        let { bookingData, data } = this.state;

        let service = 'extraServices';
        if (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) {
            return false;
        }

        let showButton = false;
        _.forEach(window.$content.extras, function (v) {
            if (v.active) {
                showButton = true;
            }
        });

        if (
            showButton &&
            !window.deactivateServices.includes('ExtraServices') &&
            data !== undefined &&
            (data.allowExtraServices === undefined || data.allowExtraServices === true)
        ) {
            if (bookingData['load-extraservices'] === undefined) {
                bookingData = storage.get('bookingData');
                bookingData['load-extraservices'] = true;
                storage.set('bookingData', bookingData);
            }

            return (
                <ExtraServices
                    setIsLoading={(loaded) => {
                        this.setIsLoading(loaded);
                    }}
                />
            );
        } else if (showButton === false && this.state.isLoading === true) {
            this.setIsLoading(false);
        } else {
            return (
                <div className="info-card">Für Ihre Reise sind im Moment leider keine Zusatzleistungen verfügbar.</div>
            );
        }
    }

    setIsLoading(props) {
        this.setState((state) => {
            state.isLoading = props;
            return state;
        });
    }

    showDocuments() {
        let { bookingData } = this.state;

        // affiliate
        if (window.$affiliate) {
            return false;
        }

        let showExcursionDocument = false;
        if (
            bookingData?.data?.frontendParams?.excursions !== undefined &&
            bookingData?.data?.frontendParams?.excursions.length > 0
        ) {
            bookingData.data.frontendParams.excursions.forEach((item) => {
                if (item.state === 'OK') {
                    showExcursionDocument = true;
                }
            });
        }

        const seatReservation = bookingData?.data?.frontendParams?.seatReservation;
        let showSeatReservationDocument = false;

        if (seatReservation !== undefined && Object.keys(seatReservation).length > 0) {
            Object.keys(seatReservation).forEach((key) => {
                const item = seatReservation[key];
                if (item.state === 'OK') {
                    showSeatReservationDocument = true;
                }
            });
        }

        return (
            <>
                {bookingData.statusCode === 200 &&
                    bookingData.data !== undefined &&
                    bookingData.data.frontendParams !== undefined && (
                        <>
                            {tripStartCountdown(bookingData.travelStart) <= 30 &&
                                bookingData.data.frontendParams?.price?.open === 0 && (
                                    <>
                                        <Documents name="traveldocument" label="Reiseunterlagen" />
                                        {bookingData.data.frontendParams.transferDetails !== undefined &&
                                            window.$content.mappingTransfer[
                                                bookingData.data.frontendParams.transferDetails.tariff.toLowerCase()
                                            ] !== undefined && (
                                                <Documents
                                                    name="traveldocument"
                                                    renderType="transfer"
                                                    label="Transfer-Voucher"
                                                />
                                            )}
                                        {showExcursionDocument && (
                                            <Documents
                                                name="traveldocument"
                                                renderType="excursion"
                                                label="Ausflugs-Voucher"
                                            />
                                        )}
                                        {showSeatReservationDocument && (
                                            <Documents
                                                name="traveldocument"
                                                renderType="seatReservation"
                                                label="Sitzplatzreservierungs-Voucher"
                                            />
                                        )}
                                        {
                                            // Todo: Wenn Rail&Fly einzeln aufgerufen werden kann, kann dies eingeblendet werden
                                            /*bookingData.data.serviceInformation.railAndFly !== undefined &&
                                    <Documents name="traveldocument" renderType="railAndFly" label="Rail&Fly-Voucher" />*/
                                        }
                                    </>
                                )}

                            <Documents name="terms" label="AurumTours AGB" />
                            <Documents name="invoicedocument" label="Rechnung" />
                            <Documents name="chattelpaper" label="Sicherungsschein" />
                        </>
                    )}

                {bookingData.travelType === 'package' && <Documents name="privacy" label="Formblatt" />}

                {/* Reiseführer kann aktuell nicht angezeigt werden */}
                {/*data.serviceInformation.travelGuide !== undefined &&
                    <Documents name="travelGuide" label="Reiseführer" />*/}
            </>
        );
    }

    needApisData() {
        // affiliate → check is allow to book service
        let service = 'apis';
        if (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) {
            return false;
        }

        let { data } = this.state;

        if (data === undefined || (data.allowApisData !== true && data.gotApisData !== true)) {
            return false;
        }

        let apisState = { state: 'show', linkType: 'internal' };

        if (data.gotApisData) {
            if (data.frontendParams.apis) {
                apisState.state = 'read-only';
                apisState.linkType = 'modal';
            } else {
                apisState.state = 'is-already-booked';
            }
        } else if (data.allowApisData) {
            if (data.alertApisData) {
                apisState.state = 'alert';
            }
        }

        if (data.allowApisData === true && data.gotApisData !== undefined) {
            if (data.allowApisData && data.gotApisData === false && tripStartCountdown(data.searchParams.depDate) < 3) {
                return (
                    <div className="info-card">
                        Da Ihr Abflug in Kürze stattfindet, können Sie leider keine Reisepassdaten mehr über den
                        AurumTours Kundenbereich übermitteln.
                        <br />
                        <br />
                        Sie können die Daten aber auch vor Ort beim Check-In an die durchführende Fluggesellschaft
                        durchgeben.
                    </div>
                );
            } else {
                return (
                    <TravelTile
                        icon="airplane_ticket"
                        name="apis"
                        headline={data.gotApisData ? 'Reisepassdaten' : 'Reisepassdaten hinterlegen'}
                        description={
                            data.gotApisData
                                ? 'Sie haben Ihre Reisepassdaten bereits eingetragen.'
                                : 'Bitte tragen Sie hier Ihre Reisepassdaten ein.'
                        }
                        state={apisState.state}
                        link="apis"
                        linkType={apisState.linkType}
                        target="_blank">
                        {data.gotApisData && data.frontendParams.apis && (
                            <>
                                <div className="banner">
                                    <p>
                                        Die übermittelten Daten stimmen nicht? Dann melden Sie sich bitte beim
                                        AurumTours Serviceteam unter{' '}
                                        <a href="mailto:service@aurumtours.de">service@aurumtours.de</a>.
                                    </p>
                                </div>
                                {Object.keys(data.frontendParams.apis).map((value, index) => {
                                    let p = data.frontendParams.apis[value];
                                    return (
                                        <div className={index % 2 === 0 ? 'left' : 'right'} key={'apis-' + index}>
                                            <div className="detail-item">
                                                <i className="material-symbols-outlined">airplane_ticket</i>
                                                <div className="e">
                                                    <h4>Reisepassdaten für {p['vollständiger Name lt. Reisepass']}</h4>
                                                    <div className="seg">
                                                        <div>Name</div>
                                                        <div>{p['vollständiger Name lt. Reisepass']}</div>
                                                    </div>
                                                    <div className="seg">
                                                        <div>Geburtsdatum</div>
                                                        <div>{p['Geburtsdatum']}</div>
                                                    </div>
                                                    <div className="seg">
                                                        <div>Geschlecht</div>
                                                        <div>{p['Geschlecht'] === 'M' ? 'männlich' : 'weiblich'}</div>
                                                    </div>
                                                    <div className="seg">
                                                        <div>Aussstellungsland des Reisepasses</div>
                                                        <div>{p['Ausstellungsland Reisepass']}</div>
                                                    </div>
                                                    <div className="seg">
                                                        <div>Staatsangehörigkeit</div>
                                                        <div>{p['Nationalität']}</div>
                                                    </div>
                                                    <div className="seg">
                                                        <div>Reisepassnummer</div>
                                                        <div>{p['Reisepassnummer']}</div>
                                                    </div>
                                                    <div className="seg">
                                                        <div>Gültig bis</div>
                                                        <div>{p['Ablaufdatum Reisepass']}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </TravelTile>
                );
            }
        }
    }

    digitalTourGuide() {
        // affiliate → check is allow to book service
        let service = 'digitalTourGuide';
        if (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) {
            return false;
        }

        const { allowDigitalTourGuide, tourGuideData } = this.state.data;

        if (allowDigitalTourGuide !== undefined && allowDigitalTourGuide === true) {
            return (
                <TravelTile
                    name="tourguide"
                    icon="phone_iphone"
                    headline={`Digitale Reiseleitung ${tourGuideData?.registered ? '' : 'aktivieren'}`}
                    description={
                        tourGuideData?.registered
                            ? 'Sie haben die Digitale Reiseleitung bereits aktiviert.'
                            : 'Wir unterstützen Sie kostenlos per WhatsApp bei Fragen und Wünschen während Ihrer Reise.'
                    }
                    state={tourGuideData?.registered ? 'read-only' : 'show'}
                    link="digitale-reiseleitung"
                    linkType={tourGuideData?.registered ? 'modal' : 'internal'}
                    target="_blank">
                    {tourGuideData.registered && tourGuideModal(tourGuideData)}
                </TravelTile>
            );
        }
    }

    emergencyContact() {
        // affiliate → check is allow to book service
        let service = 'emergencyContact';
        if (
            this.state.bookingData?.data?.allowedInteractions?.login?.reason === 'cruise-apis' ||
            (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service))
        ) {
            return false;
        }
        const emergencyContactData = this.state.data?.emergencyContactData;
        const registered = emergencyContactData?.name !== undefined && emergencyContactData?.name !== null;

        if (window.$allowEmergencyContact === 'true' && !window.deactivateServices.includes('EmergencyContact')) {
            return (
                <TravelTile
                    name="emergency-contact"
                    icon="emergency"
                    headline={registered ? 'Notfallkontakt' : 'Notfallkontakt hinzufügen'}
                    description={
                        registered
                            ? 'Sie haben Ihren Notfallkontakt bereits hinzugefügt. Hier können Sie diesen ändern.'
                            : 'Hinterlegen Sie Ihre Kontaktnummer, damit wir Sie im Notfall schnellstmöglich erreichen können.'
                    }
                    state={registered ? 'editable' : 'show'}
                    link="notfall-kontakt"
                    linkType={registered ? 'modal' : 'internal'}
                    target="_blank">
                    {registered && EmergencyContactModal(emergencyContactData)}
                </TravelTile>
            );
        }
    }

    bookingDetails() {
        // affiliate
        if (window.$affiliate) {
            return false;
        }

        const { data } = this.state;
        const bookingState = this.#bookingState;

        if (data !== undefined && data.serviceInformation !== undefined) {
            switch (true) {
                case data.serviceInformation.package.state === 'OK' ||
                    data.serviceInformation.package.state === 'MO' ||
                    data.serviceInformation.package.state === 'XX' ||
                    data.serviceInformation.package.state === 'TB':
                    return <BookingDetails bookingData={this.state.bookingData} bookingState={bookingState} />;
                case data.serviceInformation.package.state === 'SB':
                    return (
                        <article className="info-card">
                            <p>
                                Ihre Buchung wird gerade überprüft. Bitte loggen Sie sich zu einem späteren Zeitpunkt
                                noch einmal in den Kundenbereich ein. Danke.
                            </p>
                        </article>
                    );
                default:
                    break;
            }
        }
    }

    allDone() {
        if (
            this.updatePayment() === undefined &&
            this.updatePaymentRefundData() === undefined &&
            this.updateExtraServices() === undefined &&
            this.digitalTourGuide() === undefined &&
            this.emergencyContact() === undefined &&
            this.flightAlternativeSearch() === undefined &&
            null === this.claim() &&
            this.needApisData() === undefined &&
            this.bookingDetails() === undefined
        ) {
            return (
                <div>
                    <h2 className="heading">Alles erledigt. Keine Aktionen möglich.</h2>
                </div>
            );
        }
    }

    render() {
        const { data, bookingNumber } = this.state;
        if (data === null) return;
        if (storage.get('access_token')) {
            tracking('loaded', 'tilePage');
        }

        // no render for deeplink
        if (storage.get('deeplink') !== undefined && storage.get('deeplink')) {
            return false;
        }

        let showCancellation = false;
        if (data?.allowedInteractions?.cancellation) {
            const { cancellation } = data?.allowedInteractions;

            showCancellation =
                cancellation?.completeCancellation ||
                Object.values(cancellation.partialCancellation).some((value) => value === true);
        }

        this.#sideBarNavigationList = [];

        // affiliate
        if (window.$affiliate) {
            if (
                this.#bookingState === 'OK' &&
                affiliate_checkIsAllowToBookService('extraServices').includes('extraServices')
            ) {
                this.#sideBarNavigationList.push({
                    label: 'Zusatzleistungen buchen',
                    name: 'zusatzleistung',
                    icon: 'attractions',
                    index: 3,
                });
            }
            if (this.#bookingState === 'over' && affiliate_checkIsAllowToBookService('claim').includes('claim')) {
                this.#sideBarNavigationList.push({
                    label: 'Reise reklamieren',
                    name: 'reise-reklamieren',
                    icon: 'sync_problem',
                    index: 6,
                });
            }
        } else {
            if (window.$browserInfo.device !== 'mobile') {
                this.#sideBarNavigationList.push({
                    label: 'Buchungsübersicht',
                    name: 'buchungsuebersicht',
                    icon: 'explore',
                    index: 0,
                });
            }
            if (this.#bookingState === 'over') {
                this.#sideBarNavigationList.push({
                    label: 'Zahlungsstatus einsehen',
                    name: 'zahlungsstatus',
                    icon: 'euro',
                    index: 4,
                });
                if (this.context?.travelType !== 'cruise') {
                    this.#sideBarNavigationList.push({
                        label: 'Reise reklamieren',
                        name: 'reise-reklamieren',
                        icon: 'sync_problem',
                        index: 6,
                    });
                }
            } else if (this.#bookingState === 'OK') {
                this.#sideBarNavigationList.push(
                    {
                        label: 'Buchung verwalten oder ändern',
                        name: 'buchung-verwalten',
                        icon: 'edit_note',
                        index: 1,
                        alertCount: this.state.alertCount?.manageBooking,
                    },
                    { label: 'Dokumente anzeigen', name: 'dokumente-anzeigen', icon: 'description', index: 2 },
                    { label: 'Zusatzleistungen buchen', name: 'zusatzleistung', icon: 'attractions', index: 3 },
                    { label: 'Zahlungsstatus einsehen', name: 'zahlungsstatus', icon: 'euro', index: 4 }
                );
                if (showCancellation) {
                    this.#sideBarNavigationList.push({
                        label: 'Stornierungsoptionen',
                        name: 'stornierungsoptionen',
                        icon: 'free_cancellation',
                        index: 5,
                    });
                }
                if (this.context?.travelType !== 'cruise') {
                    this.#sideBarNavigationList.push({
                        label: 'Reise reklamieren',
                        name: 'reise-reklamieren',
                        icon: 'sync_problem',
                        index: 6,
                    });
                }
            } else if (this.#bookingState === 'XX') {
                this.#sideBarNavigationList.push({
                    label: 'Zahlungsstatus einsehen',
                    name: 'zahlungsstatus',
                    icon: 'euro',
                    index: 4,
                });
            }

            // check : deactive services
            let cleanUpsideBarNavigationList = this.#sideBarNavigationList;
            _.forEach(window.$deactivateExtras, function (service) {
                switch (service.toLowerCase()) {
                    case 'cancellation':
                        cleanUpsideBarNavigationList = _.filter(cleanUpsideBarNavigationList, function (o) {
                            return o.name !== 'stornierungsoptionen';
                        });
                        break;
                    default:
                        break;
                }
            });

            this.#sideBarNavigationList = cleanUpsideBarNavigationList;
        }

        const bookingCancellationInfo = (
            <div className="booking-alert status-xx">
                <i className="material-symbols-outlined">free_cancellation</i>
                <p>
                    Diese Reise wurde storniert. Weitere Informationen haben Sie per E-Mail erhalten. Bitte wenden Sie
                    sich bei offenen Fragen an das AurumTours Serviceteam.
                </p>
            </div>
        );

        return (
            <div className="page-index">
                {window.$browserInfo.device === 'mobile' ? (
                    this.state.currentStep === 0 && <Header bookingState={this.#bookingState} />
                ) : (
                    <Header bookingState={this.#bookingState} />
                )}

                {this.#bookingState === 'NO' && (
                    <>
                        <div className="content-wrapper booking-no">
                            <div className="booking-info">
                                <h1>
                                    {this.context?.constants?.MY_TRIP} {getRegion(data)}
                                </h1>
                                <span className="booking-number">Buchungsnummer {bookingNumber}</span>
                            </div>
                        </div>
                        <StatusPage type="warning" subPage="index" bookingState={this.#bookingState} />
                    </>
                )}

                {data && this.#bookingState !== 'NO' && (
                    <div className="content-wrapper ">
                        <div className="side-navigation">
                            <div className="side-navigation-head">
                                <h1>
                                    {this.context?.constants?.MY_TRIP}{' '}
                                    {this.context?.travelType === 'package' &&
                                        getRegion(data.frontendParams.hotelDetails)}
                                </h1>
                                <span className="booking-number">Buchungsnummer {bookingNumber}</span>
                                <HeroTeaser
                                    state="customerarea"
                                    effect="blur"
                                    bookingState={this.#bookingState}
                                    depDate={data.searchParams.depDate}
                                />
                            </div>

                            {window.$browserInfo.device === 'mobile' && this.state.currentStep === 0 && (
                                <div className="booking-details">
                                    {/* booking cancelled */}
                                    {this.#bookingState === 'XX' && bookingCancellationInfo}

                                    {/* booking okay */}
                                    {this.#bookingState !== 'XX' && this.bookingDetails()}
                                </div>
                            )}

                            <div className="side-navigation-body">
                                <SideNavigation
                                    currentStep={this.state.currentStep}
                                    navigationList={this.#sideBarNavigationList}
                                />
                            </div>
                        </div>

                        {
                            /* Meine Reise */
                            this.state.currentStep === 0 && window.$browserInfo.device !== 'mobile' && (
                                <div
                                    className={`tab-content-container booking-details ${
                                        this.#bookingState === 'XX' ? 'booking-xx' : ''
                                    }`}>
                                    {window.$browserInfo.device === 'mobile' && (
                                        <div className="modal-mobile-background-layer"></div>
                                    )}
                                    {(() => {
                                        switch (this.#bookingState) {
                                            //  booking cancelled
                                            case 'XX':
                                                return (
                                                    <>
                                                        <div className="tab-header">
                                                            <h3>Ihre Buchung wurde storniert</h3>
                                                        </div>
                                                        {bookingCancellationInfo}
                                                    </>
                                                );

                                            //  default
                                            default:
                                                return (
                                                    <>
                                                        <div className="tab-header">
                                                            <h3>Buchungsübersicht</h3>
                                                        </div>
                                                        {this.bookingDetails()}
                                                    </>
                                                );
                                        }
                                    })()}
                                </div>
                            )
                        }

                        {
                            /* manage booking */
                            /* flight, accommodation, emergency Contact, drl, apis */
                            this.state.currentStep === 1 && (
                                <div className="tab-content-container">
                                    {window.$browserInfo.device === 'mobile' && (
                                        <div className="modal-mobile-background-layer"></div>
                                    )}
                                    <div className="tab-header">
                                        <h3>Buchung</h3>
                                        {window.$browserInfo.device === 'mobile' && (
                                            <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                                                <i className="material-symbols-outlined">close</i>
                                            </Link>
                                        )}
                                    </div>
                                    <div className="tab-content">
                                        {this.flightAlternativeATC()}
                                        {this.flightAlternativeSearch()}
                                        {this.hotelAlternativeSearch()}
                                        {this.changeSeatReservation()}
                                        {this.changeExcursion()}
                                        {this.emergencyContact()}
                                        {this.digitalTourGuide()}
                                        {this.needApisData()}
                                        {this.state.bookingData?.data?.allowedInteractions?.login?.reason !==
                                            'cruise-apis' && (
                                            <div className="info-text">
                                                Zusatzleistungen für Ihre Reise finden Sie{' '}
                                                <Link rel="noopener noreferrer" className="link" to={'/zusatzleistung'}>
                                                    hier
                                                </Link>
                                                .
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        }

                        {
                            /* show documents */
                            this.state.currentStep === 2 && (
                                <div className="tab-content-container documents">
                                    {window.$browserInfo.device === 'mobile' && (
                                        <div className="modal-mobile-background-layer"></div>
                                    )}
                                    <div className="tab-header">
                                        <h3>
                                            Dokumente
                                            {window.$browserInfo.device !== 'mobile' && (
                                                <i className="material-symbols-outlined">
                                                    info
                                                    <div className="tooltip">
                                                        Das Dokument lässt sich nicht herunterladen? Versuchen Sie es
                                                        bitte mit einem anderen Webbrowser.
                                                    </div>
                                                </i>
                                            )}
                                        </h3>
                                        {window.$browserInfo.device === 'mobile' && (
                                            <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                                                <i className="material-symbols-outlined">close</i>
                                            </Link>
                                        )}
                                    </div>
                                    <div className="tab-content">
                                        {this.showDocuments()}
                                        {window.$browserInfo.device === 'mobile' && (
                                            <div className="info-text">
                                                Das Dokument lässt sich nicht herunterladen? Versuchen Sie es bitte mit
                                                einem anderen Webbrowser.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        }

                        {
                            /* extra services */
                            this.state.currentStep === 3 && (
                                <div className="tab-content-container extra-services">
                                    {window.$browserInfo.device === 'mobile' && (
                                        <div className="modal-mobile-background-layer"></div>
                                    )}
                                    <div className="tab-header">
                                        <h3>Zusatzleistungen</h3>
                                        {window.$browserInfo.device === 'mobile' && (
                                            <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                                                <i className="material-symbols-outlined">close</i>
                                            </Link>
                                        )}
                                    </div>
                                    <div className="tab-content">
                                        {this.updateExtraServices()}
                                        <div className="info-text">
                                            Wenn Sie an Ihrer Buchung eine Änderung vornehmen möchten klicken Sie{' '}
                                            <Link rel="noopener noreferrer" className="link" to={'/buchung-verwalten'}>
                                                hier
                                            </Link>
                                            .
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                        {
                            /* payment */
                            this.state.currentStep === 4 && (
                                <div className="tab-content-container">
                                    {window.$browserInfo.device === 'mobile' && (
                                        <div className="modal-mobile-background-layer"></div>
                                    )}
                                    <div className="tab-header">
                                        <h3>Zahlungen</h3>
                                        {window.$browserInfo.device === 'mobile' && (
                                            <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                                                <i className="material-symbols-outlined">close</i>
                                            </Link>
                                        )}
                                    </div>
                                    <div className="tab-content">{this.updatePayment()}</div>
                                </div>
                            )
                        }

                        {
                            /* cancellation */
                            this.state.currentStep === 5 && (
                                <div className="tab-content-container">
                                    {window.$browserInfo.device === 'mobile' && (
                                        <div className="modal-mobile-background-layer"></div>
                                    )}
                                    <div className="tab-header">
                                        <h3>Stornierungsoptionen</h3>
                                        {window.$browserInfo.device === 'mobile' && (
                                            <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                                                <i className="material-symbols-outlined">close</i>
                                            </Link>
                                        )}
                                    </div>
                                    <div className="tab-content">
                                        {this.cancellationService()}
                                        {this.partialCancellation()}

                                        {/* fallback in case of no possible cancellation */}
                                        {!this.cancellationService() && !this.partialCancellation() && (
                                            <article className="info-card">
                                                Für Ihre Reise sind im Moment leider keine Stornierungsoptionen
                                                verfügbar.
                                            </article>
                                        )}
                                    </div>
                                </div>
                            )
                        }

                        {
                            /* claim */
                            this.state.currentStep === 6 && (
                                <div className="tab-content-container">
                                    {window.$browserInfo.device === 'mobile' && (
                                        <div className="modal-mobile-background-layer"></div>
                                    )}
                                    <div className="tab-header">
                                        <h3>Reklamation</h3>
                                        {window.$browserInfo.device === 'mobile' && (
                                            <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                                                <i className="material-symbols-outlined">close</i>
                                            </Link>
                                        )}
                                    </div>
                                    <div className="tab-content">{this.claim()}</div>
                                </div>
                            )
                        }

                        {
                            /* fallback */
                            (this.state.currentStep < 0 || this.state.currentStep > 5) && this.allDone()
                        }
                    </div>
                )}

                <Footer />
            </div>
        );
    }
}

export default memo(Index);
